var React = require('react');

function CurrentTool (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"6","cy":"6","r":"4","fill":"#2D87F3","key":0}),React.createElement("circle",{"cx":"6","cy":"6","r":"5.5","stroke":"#2D87F3","key":1})]);
}

CurrentTool.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = CurrentTool;

CurrentTool.default = CurrentTool;
